module.exports = __webpack_public_path__ + "static/media/pomade.3d73e6ea.png";